import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Socket } from 'ngx-socket-io';


@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class SocketModule extends Socket{ 
  constructor() {
    super({url:'http://localhost:8080', options:{} });
  }
}
